import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import web3 from "web3";

import AuctionDetails from "./components/auctionDetails";
import BuyGeosModal from "./components/buyGeosModal";
import DownloadsModal from "./components/downloadsModal";
import Footer from "./components/footer";
import Header from "./components/header";
import Home from "./components/home";
import Layout from "./components/layout";
import MyAuctions from "./components/myAuctions";
import MyBids from "./components/myBids";
import Notifications from "./components/notifications";
import WalletSelector from "./components/walletSelector";

import { W3Context } from "./services/context";
import getContracts from "./services/contract/getContracts";

import { toFormattedGeoTokensAmount } from "./utils/amount";
import PATHS from "./utils/paths";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-multi-carousel/lib/styles.css";
import "react-toastify/dist/ReactToastify.min.css";

import "./App.css";

const { geosContract, farmingContract } = getContracts();

const { REACT_APP_AUTH } = process.env;

const GAS_FEE = "800";

axios.interceptors.request.use((request) => {
  request.headers["Authorization"] = `Basic ${REACT_APP_AUTH}`;

  return request;
});

const App = () => {
  const { active, account, library } = useContext(W3Context);

  const [geoTokensAmountHeader, setGeoTokensAmountHeader] = useState("-");
  const [NFTsAmount, setNFTsAmount] = useState("-");
  const [geoSpinsAmountHeader, setGeoSpinsAmountHeader] = useState("-");

  const [displayBuyGEOTokens, setDisplayBuyGEOTokens] = useState(false);
  const [displayConnectWalletModal, setDisplayConnectWalletModal] =
    useState(false);
  const [displayDownloads, setDisplayDownloads] = useState(false);

  const getAvailableGeosAmount = async () => {
    console.log("Getting available GEOs amount...");

    if (active) {
      const contract = new library.eth.Contract(
        geosContract.abi,
        geosContract.address
      );

      try {
        await contract.methods
          .balanceOf(web3.utils.toChecksumAddress(account))
          .call()
          .then((res) => {
            const amount = web3.utils.fromWei(res, "ether");
            setGeoTokensAmountHeader(toFormattedGeoTokensAmount(amount));
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {
        console.log(err);
      }
    }
  };

  const getNFTsAmount = async () => {
    console.log("Getting NFT amount...");

    if (active) {
      const contract = new library.eth.Contract(
        farmingContract.abi,
        farmingContract.address
      );

      try {
        const NFTs = await contract.methods
          .getWalletNFTs(library.utils.toChecksumAddress(account))
          .call();
        setNFTsAmount(NFTs.length);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const getGeoSpinsAmount = async () => {
    console.log("Getting GeoSpins amount...");

    if (active) {
      const contract = new library.eth.Contract(
        farmingContract.abi,
        farmingContract.address
      );
      const myAddress = library.utils.toChecksumAddress(account);

      try {
        const amount = await contract.methods.spinBalance(myAddress).call();
        setGeoSpinsAmountHeader(amount);
      } catch (err) {
        console.log(err);
      }
    }
  };

  const refreshData = () => {
    setTimeout(() => {
      getGeoSpinsAmount();
      getNFTsAmount();
      getAvailableGeosAmount();
    }, 500);
  };

  useEffect(() => {
    refreshData();
  }, [active, account]);

  return (
    <>
      <Notifications />
      <ToastContainer hideProgressBar={true} autoClose={false} />
      <WalletSelector
        displayModal={displayConnectWalletModal}
        setDisplayModal={setDisplayConnectWalletModal}
      />
      <BuyGeosModal
        displayModal={displayBuyGEOTokens}
        setDisplayModal={setDisplayBuyGEOTokens}
      />
      <DownloadsModal
        displayModal={displayDownloads}
        setDisplayModal={setDisplayDownloads}
      />
      <BrowserRouter>
        <Header
          geoTokensAmount={geoTokensAmountHeader}
          NFTsAmount={NFTsAmount}
          geoSpinsAmount={geoSpinsAmountHeader}
          setDisplayBuyGEOTokens={setDisplayBuyGEOTokens}
          setDisplayDownloads={setDisplayDownloads}
          onClickConnectWallet={() => setDisplayConnectWalletModal(true)}
        />
        <Layout>
          <Switch>
            <Route exact path={PATHS.AUCTIONS}>
              <Home
                onClickConnectWallet={() => setDisplayConnectWalletModal(true)}
              />
            </Route>
            <Route exact path={PATHS.AUCTIONS_MYAUCTIONS}>
              <MyAuctions
                onClickConnectWallet={() => setDisplayConnectWalletModal(true)}
              />
            </Route>
            <Route exact path={PATHS.AUCTIONS_MYBIDS}>
              <MyBids
                onClickConnectWallet={() => setDisplayConnectWalletModal(true)}
              />
            </Route>
            <Route exact path={PATHS.AUCTIONS_ID}>
              <AuctionDetails
                onClickConnectWallet={() => setDisplayConnectWalletModal(true)}
                GAS_FEE={GAS_FEE}
              />
            </Route>
          </Switch>
        </Layout>
      </BrowserRouter>
      <Footer />
    </>
  );
};

export default App;
